/**
 * Adzuki
 * task_manager.js
 */

(function TaskManager($, Adzuki)
{
	"use strict";

	var TaskManager = {};
	var $modal      = null;

	TaskManager.entities = [
		'reservation',
		'client',
		'group',
		'sales_op',
		'marketing_effort',
		'vendor_coop',
		'live_planner_appointment',
		// 'franchise', // not needed
	];

	TaskManager.entity_type = null;

	$(document).ready(function documentReady()
	{
		// open the task manager top menu
		$('.task-manager-link a').on('click', _openTaskManagerTopMenu);

		// closing the task manager top menu
		$('.tm-close').on('click', _closeTaskManagerTopMenu);
	});

	// General Task Manager Component
	TaskManager.classificationFieldChange = function classificationFieldChange(form_id)
	{
		var classification = $('#' + form_id + 'classification').val();
		var add_recurrence = $('#' + form_id + 'add_recurrence-1');
		var task_entities  = TaskManager.entities.slice();

		// this is not an entity, but there's a typeahead for it
		task_entities.push('task_list');

		// hide based on related fields
		$('.due-based-on-field').addClass('hidden');
		$('.due-on-field').addClass('hidden');
		$('.travel-type-field').addClass('hidden');
		$('.due-date-warning').addClass('hidden');
		$('.reminder-date-warning').addClass('hidden');

		// reset the typeaheads
		$.each(task_entities, function onEachEntity(i, entity) {
			$('.reset-' + entity + '-typeahead').trigger('click');
		});

		// hide the entity fields
		// hide entities specific typeaheads and based on fields
		$.each(task_entities, function onEachEntity(i, entity) {
			$('.' + entity + '-typeahead').addClass('hidden');
		});

		// show field to enter due date manually, if it's not a recurring task
		if (!add_recurrence.is(':checked')) {
			$('.default-due-date').removeClass('hidden');
		}

		if (classification === '') {
			// "None" classification selected, display typeahead to
			// select a task list manually
			$('.task_list-typeahead').removeClass('hidden');
		} else {
			$('.' + classification + '-typeahead').removeClass('hidden');

			if (classification === 'reservation') {
				$('.travel-type-field').removeClass('hidden');
			}

			// show based on fields if we are not making a recurring task
			if (!add_recurrence.is(':checked')) {
				_showBasedOnFields();
				TaskManager.populateDueDateBasedOn(form_id, classification);
			}
		}
	};

	TaskManager.completeTask = function completeTask($check_elem, callback)
	{
		var $row_elem   = $check_elem.parents('.table-row').first();
		var $table_elem = $row_elem.parent();
		var task_id     = $row_elem.data('task-id');
		var active_tab  = $check_elem.parents('.tab-pane.active').attr('id');
		var page_num    = $check_elem.parents('.tasks-table-container').data('page-num');

		var sort_column = $check_elem.parents('.tasks-table-container')
			.find('.table-header .order')
			.data('sort-column');

		var sort_order = $check_elem.parents('.tasks-table-container')
			.find('.table-header .order')
			.data('sort-order');

		// these tab id's that contain tasks
		// should not do the "fade out" effect
		// after being marked as completed
		var no_fadeout_tabs = [
			'filtered-tasks',
			'all-tasks-tab',
			'task-task-list',
		];

		if ($check_elem.hasClass('disabled')) {
			return;
		}

		if (task_id) {
			// no fade out effect for these kinds of tabs
			if (active_tab === undefined || _tabMustFadeout(no_fadeout_tabs, active_tab)) {
				$row_elem.fadeOut();
			}

			// disable all other complete "circles"
			$table_elem.find('.complete-task').not($check_elem).addClass('disabled');

			Adzuki.Ajax.get('/Tasks/complete/' + task_id)
				.then(function completeTask(response) {
					if (callback) {
						callback(active_tab, page_num, sort_column, sort_order);
					}

					$table_elem.find('.complete-task').removeClass('disabled');

					if (response.status === 'completed') {
						$check_elem.removeClass('text-muted');
						$check_elem.attr('data-original-title', 'Mark Task as Incomplete');
						$check_elem.children('i')
							.removeClass('fa-circle')
							.addClass('fa-check-circle');
					} else {
						$check_elem.addClass('text-muted');
						$check_elem.attr('data-original-title', 'Mark Task as Completed');
						$check_elem.children('i')
							.removeClass('fa-check-circle')
							.addClass('fa-circle');
					}
				}
			);
		}
	};

	TaskManager.dueBasedOnFieldChange = function dueBasedOnFieldChange(form_id)
	{
		var $due_based_on_field   = $('#' + form_id + 'due_based_on');
		var $due_based_days_field = $('#' + form_id + 'due_based_days');
		var $before_after_field   = $('#' + form_id + 'due_days_before_after');
		var due_based_on_txt      = $('#' + form_id + 'due_based_on option:selected').text();

		// hide warning messages
		$('.due-date-warning').addClass('hidden');
		$('.reminder-date-warning').addClass('hidden');
		$('.no-default-due-date-warning').addClass('hidden');

		// due date based on is not selected, bail out
		if ($due_based_on_field.val() === '') {
			$('.due-on-field').addClass('hidden');
			return;
		}

		// a specific date is going to be set,
		// show the due date field and bail out
		if ($due_based_on_field.val() === 'specific') {
			$('.due-on-field').addClass('hidden');
			$('.default-due-date').removeClass('hidden');
			return;
		}

		$('.due-on-field').removeClass('hidden');
		$('.default-due-date').addClass('hidden');

		$due_based_days_field.val('0');
		$before_after_field.empty();

		_handleWarnings(form_id);

		// no default due date selected (for task templates)
		// hide the due on days fields and bail out
		if ($due_based_on_field.val() === 'no_due_date') {
			$('.due-on-field').addClass('hidden');
			return;
		}

		// add before-after fields
		Adzuki.Ajax.get('/Tasks/getBeforeAfterOptions')
		.then(function populateEntityDates(response)
		{
			$.each(response, function onEachOption(key, val) {
				$before_after_field.append(
					$('<option>').text(val).attr('value', key)
				);
			});

			// concatenate the current due option
			$before_after_field.find('option').each(function onEachBeforeAfterOption(i, elem)
			{
				var cur_text = $(elem).text();
				$(elem).text(cur_text + ' ' + due_based_on_txt);
			});

			$due_based_days_field.val('0');

			// if "created" or "cancellation_date"
			// then only "After Created Date" can be selected
			if ($due_based_on_field.val() === 'created' || $due_based_on_field.val() === 'cancellation_date') {
				$before_after_field.val('after');
				$before_after_field.find('option[value="before"]').first().remove();
			}
		});
	};

	TaskManager.getLinkedReservationsAndGroups = function getLinkedReservationsAndGroups(reservation_id, form_id, task_form_id)
	{
		// check for any linked reservations
		Adzuki.Ajax.get('/Reservations/getLinkedReservations/' + reservation_id + '/1')
			.then(function linkedReservations(response) {
				var linked_text = '';

				if (response.reservation_count && response.reservation_count > 0) {
					$('#' + task_form_id + ' .linked-reservations').removeClass('hidden');

					linked_text += 'Duplicate task to ';
					linked_text += response.reservation_count;
					linked_text += ' linked reservation';

					if (response.reservation_count > 1) {
						linked_text += 's';
					}

					$('#' + task_form_id + ' .linked-reservations .linked-count').text(linked_text);
					$('#' + form_id + 'duplicate_linked').prop('checked', false);
				}
			});

		// check for any linked groups
		Adzuki.Ajax.get('/Reservations/getLinkedGroups/' + reservation_id + '/1')
			.then(function linkedGroups(response) {
				var linked_text = '';

				if (response.reservation_count && response.reservation_count > 0) {
					$('#' + task_form_id + ' .group-reservations').removeClass('hidden');

					linked_text += 'Duplicate task to ';
					linked_text += response.reservation_count;
					linked_text += ' additional group reservation';

					if (response.reservation_count > 1) {
						linked_text += 's';
					}

					$('#' + task_form_id + ' .group-reservations .group-count').text(linked_text);
					$('#' + form_id + 'duplicate_groups').prop('checked', false);
				}
			});
	};

	TaskManager.initTaskForm = function initTaskForm(form_id)
	{
		var $form_container   = $('#' + form_id + 'id').parents('form');
		var classification    = $('#' + form_id + 'classification').val();
		var task_id           = $('#' + form_id + 'id').val();
		var task_list_id      = $('#' + form_id + 'task_list_id').val();
		var $modal_form       = $('#' + form_id + 'modal_form');
		var $task_type        = $('#' + form_id + 'type');
		var $recurrence_field = $('#' + form_id + 'add_recurrence-1');
		var is_recurring      = false;

		// check if this is a recurring task
		if ($recurrence_field.length > 0 && $recurrence_field.is(':checked')) {
			is_recurring = true;
		}

		// don't initialize typeaheads on the task details form modal
		if ($modal_form.length === 0 || $modal_form.val() === 'reference_details') {
			// task list search typeahead (only used here)
			Adzuki.Typeahead(
				$('#' + form_id + 'task_list_search'),
				'/TaskLists/typeaheadSearch',
				function onSelect(task_list, $self, typeahead) {
					$self.prop('disabled', true);
					$('#' + form_id + 'task_list_id').val(task_list.id).trigger('change');
					$('.reset-task_list-typeahead').removeClass('hidden');
				}
			);

			TaskManager.initTaskTypeaheads(form_id, true, true);

			// do another check for recurrence since we don't have a radio selection on this form
			if ($modal_form && $modal_form.val() === 'reference_details') {
				if (parseInt($('#' + form_id + 'add_recurrence').val()) === 1) {
					is_recurring = true;

					// hide the due date field on the edit reference form
					// if this is a recurring task
					$('#task-reference .default-due-date').addClass('hidden');
				}
			}
		}

		// init autoheights
		TaskManager.initAutoheights();

		// no classification specified
		if (classification === '') {
			// trigger classification selection only when
			// a task list has not been selected manually
			if (task_list_id) {
				$('.task_list-typeahead').removeClass('hidden');
				$('.reset-task_list-typeahead').removeClass('hidden');
			}
		}

		// a classification has been specified
		// we are editing an existing task or
		// an entity type was pre-selected via GET params
		if (classification) {
			// only show the entity typeahead
			$form_container.find('.' + classification + '-typeahead').removeClass('hidden');
			$form_container.find('.reset-' + classification + '-typeahead').removeClass('hidden');

			$('.task_list-typeahead').addClass('hidden');

			if (classification === 'reservation') {
				$form_container.find('.travel-type-field').removeClass('hidden');
			}

			// not a recurring task, show the "due date based on" fields
			if (!is_recurring) {
				_showBasedOnFields();
			}

			// populate the due date based on only when creating a new task
			if (task_id) {
				// not a recurring task, show the due date based on fields
				if (!is_recurring) {
					if ($('#' + form_id + 'due_based_on').val() === 'specific') {
						$('.default-due-date').removeClass('hidden');
					} else {
						$('.due-on-field').removeClass('hidden');
					}
				}
			} else {
				TaskManager.populateDueDateBasedOn(form_id, classification);
			}
		}

		TaskManager.initTaskTagFields(form_id);

		// add reminder radios
		if (
			$('#' + form_id + 'add_reminder-0').length > 0
			&& $('#' + form_id + 'add_reminder-0').is(':checked')
		) {
			$('.reminder-field').addClass('hidden');
		}

		// add recurrence radios
		if (
			$('#' + form_id + 'add_recurrence-0').length > 0
			&& $('#' + form_id + 'add_recurrence-0').is(':checked')
		) {
			$('.recurrence-container').addClass('hidden');
		}

		if ($task_type.val() === 'email') {
			$('.template-groups').removeClass('hidden');
		}
	};

	TaskManager.initTaskListForm = function initTaskListForm(form_id)
	{
		var $tasks_container = $('.task-list-tasks');

		// changing the task list classification
		$('#' + form_id + 'entity_type').change(function onClassificationChange(e)
		{
			var classification = $(this).val();

			_resetAndHideTaskListTypeaheads();

			// show the appropriate typeahead
			if (classification !== 'franchise') {
				$('.' + classification + '-typeahead').removeClass('hidden');
			}
		});

		// trigger classification selection
		$('#' + form_id + 'entity_type').trigger('change');

		TaskManager.initTaskTypeaheads(form_id, false, false);

		// show existing tasks when selecting an entity
		if ($tasks_container.length > 0) {
			$.each(TaskManager.entities, function onEachEntity(i, entity) {
				$('#' + form_id + entity + '_id').on('change', function onEntityIdChanged(e)
				{
					var entity_id = $(this).val();

					if (!entity_id) {
						$tasks_container.addClass('hidden');
						$tasks_container.html('');
						return;
					}

					Adzuki.Ajax.get('/TaskLists/getTaskListTasks/' + entity + '/' + entity_id)
						.then(function getTasks(response) {
							$tasks_container.removeClass('hidden');
							$tasks_container.html(response);
						});
				});
			});
		}
	};

	TaskManager.initTaskListTemplateForm = function initTaskListTemplateForm(form_id)
	{
		// when changing the Based On select field
		$('#' + form_id + 'entity_type').change(function onEntityTypeChange(e)
		{
			var entity_type = $('#' + form_id + 'entity_type').val();

			$('.travel-type-field').addClass('hidden');

			// hide the auto apply if a based on is not specified
			if (entity_type) {
				$('.auto-start-field').removeClass('hidden');

				// show travel type field for reservation based templates
				if (entity_type === 'reservation') {
					$('.travel-type-field').removeClass('hidden');
				}
			} else {
				$('#' + form_id + 'auto_start').prop('checked', false);
				$('.auto-start-field').addClass('hidden');
			}
		});

		// change on the "Set reminder for template tasks" radio
		$('.set-reminder').change(function onSetReminderChange(e)
		{
			var set_reminder = parseInt($(this).val());

			if (set_reminder === 1) {
				$('.reminder-field').removeClass('hidden');
			} else {
				$('#' + form_id + 'reminder_days').val('').trigger('change');
				$('.reminder-field').addClass('hidden');
			}
		});

		// init reminder radios
		if (
			$('#' + form_id + 'set_reminder-0').length > 0
			&& $('#' + form_id + 'set_reminder-0').is(':checked')
		) {
			$('.reminder-field').addClass('hidden');
		}

		// trigger change of classification
		$('#' + form_id + 'entity_type').trigger('change');
	};

	TaskManager.initTaskTagFields = function initTaskTagFields(form_id)
	{
		var $tags_field = $('#' + form_id + 'tags');

		// init task tags selection
		$tags_field.selectpicker({
			width     : '100%',
			liveSearch: true,
		});

		// when a tag is selected
		$tags_field.on('changed.bs.select', function onTagSelected(e) {
			var tag_key  = $tags_field.val();
			var tag_name = $tags_field.find('option:selected').text();

			_insertTag(tag_key, tag_name, form_id);

			// reset the select field
			$tags_field.val('');
			$tags_field.selectpicker('render');
		});

		// button to create a new tag
		$('.' + form_id + 'task-create-tag-btn').on('click', function onCreateTagClick(e) {
			e.preventDefault();

			$('.' + form_id + 'task-add-tags').addClass('hidden');
			$('.' + form_id + 'task-create-tag').removeClass('hidden');
		});

		// button to save a tag entered
		$('.' + form_id + 'task-tag-save-btn').on('click', function onCreateTagClick(e) {
			var tag_name = $('#' + form_id + 'create_tag').val().trim();

			e.preventDefault();

			if (!tag_name) {
				Adzuki.StatusMessage('error', 'A name for the tag must be provided');
				return;
			}

			if (tag_name.length < 2) {
				Adzuki.StatusMessage('error', 'The name of the tag must be at least 2 characters');
				return;
			}

			Adzuki.Ajax.post('/Tasks/createTag', { name: tag_name }).then(
				function success(response) {
					var tag_key  = response.id + '|' + response.color + '|' + response.text_color;
					var tag_name = response.name;

					// insert new tag and clear the contents of the field
					_insertTag(tag_key, tag_name, form_id);
					$('#' + form_id + 'create_tag').val('');

					Adzuki.StatusMessage('success', 'The tag has been created successfully');
				}
			);
		});

		// if there are any existing tags on the task,
		// add event handlers for each of the remove buttons
		if ($('.' + form_id + 'current-task-tags .tag-selection .tags .tag').length > 0) {
			$('.' + form_id + 'current-task-tags .tag-selection .tags .tag .remove-task-tag').off()
				.on('click', { form_id: form_id }, _removeTag);
		}

		// button to cancel the creation of a tag
		$('.' + form_id + 'task-tag-cancel-btn').on('click', function onCreateTagClick(e) {
			e.preventDefault();

			$('.' + form_id + 'task-add-tags').removeClass('hidden');
			$('.' + form_id + 'task-create-tag').addClass('hidden');
			$('#' + form_id + 'create_tag').val('');
		});
	};

	TaskManager.initTaskTypeaheads = function initTaskTypeaheads(form_id, init_task_list_ta, include_cancelled)
	{
		var task_entities = TaskManager.entities.slice();

		if (init_task_list_ta) {
			// this is not an entity, but there's a typeahead for this
			task_entities.push('task_list');
		}

		// reservation search typeahead
		Adzuki.Typeahead(
			$('#' + form_id + 'reservation_search'),
			function source(term, display, $self) {
				var url = '/Reservations/searchReservations/' + term;

				if (include_cancelled) {
					url += '/1';
				}
				$self.removeClass('ajax-spinner');
				Adzuki.Ajax.get(url).then(function reservationSearch(response) {
					$self.removeClass('ajax-spinner');
					display(response);
				});
			},
			function onSelect(reservation, $self, typeahead) {
				$self.prop('disabled', true);
				$('#' + form_id + 'reservation_vendor_id').val(reservation.reservation_vendor_id);
				$('#' + form_id + 'reservation_id').val(reservation.id).trigger('change');
				$('.reset-reservation-typeahead').removeClass('hidden');
				_handleWarnings(form_id);
			}
		);

		// client search typeahead
		Adzuki.Typeahead(
			$('#' + form_id + 'client_search'),
			'/Clients/search',
			function onSelect(client, $self, typeahead) {
				$self.prop('disabled', true);
				$('#' + form_id + 'client_id').val(client.id).trigger('change');
				$('.reset-client-typeahead').removeClass('hidden');
				_handleWarnings(form_id);
			}
		);

		// group search typeahead
		Adzuki.Typeahead(
			$('#' + form_id + 'group_search'),
			'/Groups/searchPrivateGroupsTypeahead',
			function onSelect(group, $self, typeahead) {
				$self.prop('disabled', true);
				$('#' + form_id + 'group_id').val(group.id).trigger('change');
				$('.reset-group-typeahead').removeClass('hidden');
				_handleWarnings(form_id);
			}
		);

		// sales opportunity search typeahead
		Adzuki.Typeahead(
			$('#' + form_id + 'sales_op_search'),
			'/ClientOpportunities/typeaheadSearch',
			function onSelect(sales_op, $self, typeahead) {
				$self.prop('disabled', true);
				$('#' + form_id + 'sales_op_id').val(sales_op.id).trigger('change');
				$('.reset-sales_op-typeahead').removeClass('hidden');
				_handleWarnings(form_id);
			}
		);

		// marketing effort search typeahead
		Adzuki.Typeahead(
			$('#' + form_id + 'marketing_effort_search'),
			'/MarketingEfforts/typeaheadSearch',
			function onSelect(marketing_effort, $self, typeahead) {
				$self.prop('disabled', true);
				$('#' + form_id + 'marketing_effort_id').val(marketing_effort.id).trigger('change');
				$('.reset-marketing_effort-typeahead').removeClass('hidden');
				_handleWarnings(form_id);
			}
		);

		// vendor co-op search typeahead
		Adzuki.Typeahead(
			$('#' + form_id + 'vendor_coop_search'),
			'/VendorCoop/typeaheadSearch',
			function onSelect(vendor_coop, $self, typeahead) {
				$self.prop('disabled', true);
				$('#' + form_id + 'vendor_coop_id').val(vendor_coop.id).trigger('change');
				$('.reset-vendor_coop-typeahead').removeClass('hidden');
				_handleWarnings(form_id);
			}
		);

		// live planner appointment search typeahead
		Adzuki.Typeahead(
			$('#' + form_id + 'live_planner_appointment_search'),
			'/LivePlanner/typeaheadSearch',
			function onSelect(lp_appointment, $self, typeahead) {
				$self.prop('disabled', true);
				$('#' + form_id + 'live_planner_appointment_id').val(lp_appointment.id).trigger('change');
				$('.reset-live_planner_appointment-typeahead').removeClass('hidden');
				_handleWarnings(form_id);
			}
		);

		// click on button to reset entity typeahead
		$.each(task_entities, function onEachEntity(i, entity) {
			$('.reset-' + entity + '-typeahead').click(function onClickResetTypeahead(e)
			{
				e.preventDefault();

				// hide reset button and reset typeahead fields
				$('.reset-' + entity + '-typeahead').addClass('hidden');
				$('#' + form_id + entity + '_search').prop('disabled', false);
				$('#' + form_id + entity + '_search').val('');
				$('#' + form_id + entity + '_id').val('').trigger('change');
				$('#' + form_id + 'reservation_vendor_id').val('');

				// hide warning messages, based on date not found
				// and reminder date in the past
				$('.due-date-warning').addClass('hidden');
				$('.reminder-date-warning').addClass('hidden');
			});
		});
	};

	// init any textareas that have autoheight class
	TaskManager.initAutoheights = function initAutoheights()
	{
		if ($('textarea.autoheight').length) {
			Adzuki.TextareaAutoheight($('textarea.autoheight'));
		}
	};

	// loading the tasks for an entity section (reservation, client etc. etc.)
	TaskManager.loadEntityTasks = function loadEntityTasks(entity_type)
	{
		TaskManager.entity_type = entity_type;

		$('body').on('ajax-pagination.loaded', function onAjaxLoaded() {
			var $incomplete_tasks = $('#entity-incomplete-tasks .table-header-sort');
			var $completed_tasks  = $('#entity-completed-tasks .table-header-sort');

			$('.task-details').off().on('click', _openTaskDetailsFromEntitySection);
			$('.complete-task').off().on('click', _completeTaskFromEntitySection);
			$('.pin-task').off().on('click', _pinTaskFromEntitySection);

			TaskManager.sortTable($incomplete_tasks, function callback(active_tab, page_num, order_by, sort_order)
			{
				_loadEntityTasks(active_tab, page_num, order_by, sort_order);
			});

			TaskManager.sortTable($completed_tasks, function callback(active_tab, page_num, order_by, sort_order)
			{
				_loadEntityTasks(active_tab, page_num, order_by, sort_order);
			});
		});

		_loadEntityTasks();
	};

	TaskManager.openTaskDetails = function openTaskDetails($anchor_elem)
	{
		var $row_elem   = $anchor_elem.parents('.table-row').first();
		var task_id     = $row_elem.data('task-id');
		var task_tab    = $row_elem.data('task-tab');
		var read_only   = $row_elem.data('read-only');
		var modal_title = 'Task Details';
		var url         = '/Tasks/view/' + task_id;
		$modal          = $('.modal');

		if ($anchor_elem.data('task-name')) {
			modal_title = $anchor_elem.data('task-name');
		}

		if (read_only) {
			url += '/1';
		}

		// modal title
		$modal.find('.modal-title').text(modal_title);

		Adzuki.Ajax.get(url)
			.then(function viewTask(response) {
				$modal.find('.modal-body').html(response);
				$modal.modal('show');
				$modal.on('hide.bs.modal', function modalClose() {
					var change_made = $('#task-details-nav').data('changed');

					if (change_made && change_made === 1) {
						_reloadPage();
					}

					$modal.off('hide.bs.modal');
				});

				$modal.on('hidden.bs.modal', function modalHidden() {
					$modal.find('.modal-body').html('');
					$modal.off('hidden.bs.modal');
				});

				_renderTaskDetailsView(task_id, read_only);
				_renderTaskReferenceView(task_id, read_only);
				_renderTaskCommentsView(task_id);
				_renderTaskAttachmentsView(task_id);
				_renderTaskHistoryView(task_id);

				// don't display these on "read only" mode
				if (!read_only) {
					_renderTaskOutcomeView(task_id);
					_renderTaskListView(task_id);
				}

				// display a specific tab
				if (task_tab) {
					$('#task-details-nav #task-' + task_tab + '-tab a').trigger('click');
				}
			});
	};

	TaskManager.pinTask = function pinTask($pin_elem, callback)
	{
		var $row_elem  = $pin_elem.parents('.table-row').first();
		var task_id    = $row_elem.data('task-id');
		var active_tab = $pin_elem.parents('.tab-pane.active').attr('id');
		var page_num   = $pin_elem.parents('.tasks-table-container').data('page-num');

		var sort_column = $pin_elem.parents('.tasks-table-container')
			.find('.table-header .order')
			.data('sort-column');

		var sort_order = $pin_elem.parents('.tasks-table-container')
			.find('.table-header .order')
			.data('sort-order');

		// these tab id's that contain tasks
		// should not do the "fade out" effect
		// after being pinned or unpinned
		var no_fadeout_tabs = [
			'filtered-tasks',
			'past-due-tasks',
			'upcoming-tasks',
			'all-tasks-tab',
			'due-tasks-tab',
			'today-tasks-tab',
			'homepage-today-tasks-tab',
			'week-tasks-tab',
			'month-tasks-tab',
			'entity-incomplete-tasks',
			'entity-completed-tasks',
			'top-past_due',
			'top-today',
			'top-this_week',
			'top-recently_viewed',
		];

		if (task_id) {
			// no fade out effect for these kinds of tabs
			if (active_tab === undefined || _tabMustFadeout(no_fadeout_tabs, active_tab)) {
				$row_elem.fadeOut();
			}

			Adzuki.Ajax.get('/Tasks/pin/' + task_id)
				.then(function pinTask(response) {
					if (response.status === 'pinned') {
						$pin_elem.removeClass('text-muted');
						$pin_elem.attr('data-original-title', 'Unpin Task');
					} else {
						$pin_elem.addClass('text-muted');
						$pin_elem.attr('data-original-title', 'Pin Task');
					}
					if (callback) {
						callback(active_tab, page_num, sort_column, sort_order);
					}
				}
			);
		}
	};

	TaskManager.populateDueDateBasedOn = function populateDueDateBasedOn(form_id, entity_type)
	{
		var $due_based_on_field = $('#' + form_id + 'due_based_on');
		var sorted_data         = [];
		var entity_data         = [];
		var entity_id           = $('#' + form_id + entity_type + '_id').val();
		var url                 = '/Tasks/getClassificationDates/' + entity_type;

		if (entity_id) {
			url += '/' + entity_id;
		}

		Adzuki.Ajax.get(url).then(function populateEntityDates(response)
		{
			$due_based_on_field.empty();
			$due_based_on_field.append(
				$('<option>').text('Select a Due Date Based On').attr('value', '')
			);

			sorted_data = Adzuki.Sort.alphabeticValue(response);

			$.each(sorted_data, function appendOption(key, val) {
				entity_data.push($('<option>').text(val.value).attr('value', val.key));
			});

			$due_based_on_field.append(entity_data);

			$due_based_on_field.append(
				$('<option>').text('Specific Date').attr('value', 'specific')
			);

			$('#' + form_id + 'due_based_on').trigger('change');
		});
	};

	TaskManager.sortTable = function sortTable($table, callback)
	{
		var arrow_up   = '<i class="' + Adzuki.FaIcon.getIconStyle('arrow_up') + '"></i>';
		var arrow_down = '<i class="' + Adzuki.FaIcon.getIconStyle('arrow_down') + '"></i>';

		$table.find('.table-header > p').each(function onEachHeader(i, elem)
		{
			// ignore columns that are not meant to be sorted
			if ($(elem).hasClass('no-sort')) {
				return; // continue
			}

			$(elem).off().on('click', function onHeaderClick(e)
			{
				var $self      = $(this);
				var order      = 'asc';
				var order_icon = arrow_up;
				var column     = null;
				var active_tab = $self.parents('.tab-pane.active').attr('id');

				if ($self.data('sort-column')) {
					column = $self.data('sort-column');
				}

				// clicked on the same header again, invert the order
				if ($self.hasClass('asc')) {
					order      = 'desc';
					order_icon = arrow_down;
				} else if ($self.hasClass('desc')) {
					order      = 'asc';
					order_icon = arrow_up;
				}

				$table.find('.table-header > p').each(function updateHeaders(j, header_elem)
				{
					$(header_elem).removeClass('order asc desc')
					.find('i').first().remove();
				});

				$self.addClass('order');

				if (order !== '') {
					$self.addClass(order);
				}

				$self.html($self.html() + ' ' + order_icon);

				if (column && callback) {
					callback(active_tab, 1, column, order);
				}
			});
		});
	};

	TaskManager.renderTaskListView = function renderTaskListView(task_id)
	{
		_renderTaskListView(task_id);
	};

	TaskManager.renderTaskReferenceView = function renderTaskReferenceView(task_id)
	{
		_renderTaskReferenceView(task_id);
	};

	TaskManager.showBasedOnWarning = function showBasedOnWarning(form_id)
	{
		var entity_type = $('#' + form_id + 'classification').val();
		var entity_id   = null;
		var form_data   = null;

		if ($('.due-date-warning').length === 0) {
			return;
		}

		$('.due-date-warning').addClass('hidden');

		if (!entity_type) {
			return;
		}

		entity_id = $('#' + form_id + entity_type + '_id').val();

		if (!entity_id) {
			return;
		}

		form_data = $('#task_add_edit').serialize();

		Adzuki.Ajax.post('/Tasks/checkEntityBasedOnDate', form_data)
		.then(function checkBasedOnDate(response)
		{
			var msg = '';

			if (response.error) {
				return;
			}

			if (response.invalid === true) {
				msg = '<strong>Please Note:</strong> you are basing the due date on ';
				msg += response.column_name + ', however the ';
				msg += response.entity_name + ' does not have a date entered for that field.';
				msg += ' The due date of this task will be set to the current date.';

				$('.due-date-warning').html(msg);
				$('.due-date-warning').removeClass('hidden');
			} else if (response.past === true) {
				msg = '<strong>Please Note:</strong> the due date for this task ';
				msg += '(' + response.entity_name + ') will be set in the past.';

				$('.due-date-warning').html(msg);
				$('.due-date-warning').removeClass('hidden');
			}
		});
	};

	TaskManager.showReminderWarning = function showReminderWarning(form_id)
	{
		var entity_type   = $('#' + form_id + 'classification').val();
		var entity_id     = null;
		var form_data     = null;
		var reminder_date = null;
		var reminder_days = 0;
		var $remind_me    = $('#' + form_id + 'reminder_days');
		var $due_date     = $('#' + form_id + 'due_date');
		var $due_based_on = $('#' + form_id + 'due_based_on');
		var msg           = '';

		if ($('.reminder-date-warning').length === 0) {
			return;
		}

		$('.reminder-date-warning').addClass('hidden');

		if (!$('#' + form_id + 'add_reminder-1').is(':checked')) {
			return;
		}

		// no entity type or specific date selected for based on, use the due date entered (if any)
		if (!entity_type || $due_based_on.val() === 'specific') {
			if ($remind_me.val() !== '' && $due_date.data('DateTimePicker').date()) {
				reminder_days = parseInt($remind_me.val());
				reminder_date = $due_date.data('DateTimePicker').date().subtract(reminder_days, 'days');

				if (reminder_date.isBefore(moment().format('YYYY-MM-DD'))) {
					msg = '<strong>Please Note:</strong> the reminder date for this task will be set in the past.';

					$('.reminder-date-warning').html(msg);
					$('.reminder-date-warning').removeClass('hidden');
				}
			}
			return;
		}

		entity_id = $('#' + form_id + entity_type + '_id').val();

		if (!entity_id) {
			return;
		}

		form_data = $('#task_add_edit').serialize();

		Adzuki.Ajax.post('/Tasks/checkEntityReminderDate', form_data)
		.then(function checkEntityReminderDate(response)
		{
			msg = '';

			if (response.error) {
				return;
			}

			if (response.past === true) {
				msg = '<strong>Please Note:</strong> the reminder date for this task ';
				msg += '(' + response.entity_name + ') will be set in the past.';

				$('.reminder-date-warning').html(msg);
				$('.reminder-date-warning').removeClass('hidden');
			}
		});
	};

	// Start private functions
	function _completeTaskFromTopMenu(e)
	{
		var $check_elem = $(this);

		e.preventDefault();

		TaskManager.completeTask($check_elem, function completeTaskCb(active_tab, page_num) {
			_updateTopMenuTabNumbers();
			_loadTopMenuTabs();

			// flag that we made updates
			$('.tm-close').data('changed', 1);
		});
	}

	function _completeTaskFromEntitySection(e)
	{
		var $check_elem = $(this);

		e.preventDefault();

		TaskManager.completeTask($check_elem, function completeTaskCb(active_tab, page_num, order_by, sort_order) {
			_loadEntityTasks(active_tab, page_num, order_by, sort_order);
		});
	}

	function _closeTaskManagerTopMenu(e)
	{
		var change_made = $(this).data('changed');

		$('.task-manager-container').slideToggle('fast');
		$('.task-manager-link a').css('background-color', 'transparent');

		// if we are on the task manager dashboard and some changes were done to a
		// task on the top menu (completed a task or pinned a task)
		// then reload the page so that everything is up to date
		if (
			$('#tasks .task-dashboard-actions').length > 0
			&& $('#tasks').hasClass('active')
			&& change_made === 1
		) {
			window.location.reload();
		}
	}

	function _handleWarnings(form_id)
	{
		TaskManager.showBasedOnWarning(form_id);
		TaskManager.showReminderWarning(form_id);
		_showNoDefaultDueDateWarning(form_id);
	}

	function _insertTag(tag_key, tag_name, form_id)
	{
		var items          = tag_key.split('|');
		var tag_id         = items[0];
		var tag_color      = items[1];
		var tag_text_color = items[2];
		var tag_markup     = '';
		var icon           = Adzuki.FaIcon.getIconStyle('delete_not_red', 'solid');
		var tag_ids_str    = $('#' + form_id + 'tag_ids').val();
		var tag_ids        = [];
		var tag_added      = false;

		if (tag_ids_str) {
			tag_ids = tag_ids_str.split(',');
		}

		// if the tag is already inserted, bail out
		if (tag_ids.length > 0) {
			$.each(tag_ids, function onEachTagId(i, id) {
				if (tag_id === id) {
					tag_added = true;
					return false; // break
				}
			});
		}

		if (tag_added) {
			return;
		}

		// build markup for the selected tag
		tag_markup += '<span class="tag" ';
		tag_markup += 'style="border-color: ' + tag_color + '; ';
		tag_markup += 'background-color: ' + tag_color + ';">';
		tag_markup += '<span style="cursor:pointer;" class="remove-task-tag" data-tag-id="' + tag_id + '">';
		tag_markup += '<i class="adzicon-delete_not_red ' + icon + '" style="color: ' + tag_text_color + ';"></i></span>';
		tag_markup += '<span class="title" style="color:' + tag_text_color + ';">';
		tag_markup += ' ' + tag_name + '</span>';
		tag_markup += '</span>';

		$('.' + form_id + 'current-task-tags .tag-selection .tags').append(tag_markup);

		tag_ids.push(tag_id);
		tag_ids_str = tag_ids.join(',');

		$('#' + form_id + 'tag_ids').val(tag_ids_str);

		// event handler to remove the tag
		$('.' + form_id + 'current-task-tags .tag-selection .tags .remove-task-tag').off()
			.on('click', { form_id: form_id }, _removeTag);

		// show checkbox to match all tags (only applies in the filter screens)
		if (
			$('.' + form_id + 'match-tags').length > 0
			&& tag_ids.length > 1
		) {
			$('.' + form_id + 'match-tags').removeClass('hidden');
		}
	}

	function _loadEntityTasks(active_tab, page_num, order_by, sort_order)
	{
		var entity_id             = $('#entity-incomplete-tasks').data('entity-id');
		var incomplete_page_num   = 1;
		var completed_page_num    = 1;
		var incomplete_order_by   = 'due_date';
		var completed_order_by    = 'due_date';
		var incomplete_sort_order = 'asc';
		var completed_sort_order  = 'asc';
		var incomplete_url        = '';
		var completed_url         = '';

		if (active_tab && page_num) {
			switch (active_tab) {
				case 'entity-incomplete-tasks':
					incomplete_page_num = page_num;
					if (order_by && sort_order) {
						incomplete_order_by   = order_by;
						incomplete_sort_order = sort_order;
					}
				break;
				case 'entity-completed-tasks':
					completed_page_num = page_num;
					if (order_by && sort_order) {
						completed_order_by   = order_by;
						completed_sort_order = sort_order;
					}
				break;
				default:
					// happy linter
			}
		}

		incomplete_url = '/Tasks/getEntityIncompleteTasks/' + TaskManager.entity_type + '/' + entity_id;
		incomplete_url += '/page_num:' + incomplete_page_num;
		incomplete_url += '/order_by:' + incomplete_order_by;
		incomplete_url += '/sort_order:' + incomplete_sort_order;

		completed_url = '/Tasks/getEntityCompletedTasks/' + TaskManager.entity_type + '/' + entity_id;
		completed_url += '/page_num:' + completed_page_num;
		completed_url += '/order_by:' + completed_order_by;
		completed_url += '/sort_order:' + completed_sort_order;

		Adzuki.Ajax.get(incomplete_url)
			.then(function populateIncompleteTasks(response) {
				$('#entity-incomplete-tasks').html(response);
				$('.task-details').off().on('click', _openTaskDetailsFromEntitySection);
				$('.complete-task').off().on('click', _completeTaskFromEntitySection);
				$('.pin-task').off().on('click', _pinTaskFromEntitySection);

				_showOrHideTasksButtons();

				TaskManager.sortTable($('#entity-incomplete-tasks .table-header-sort'), function callback(active_tab, page_num, order_by, sort_order)
				{
					_loadEntityTasks(active_tab, page_num, order_by, sort_order);
				});
			}
		);

		Adzuki.Ajax.get(completed_url)
			.then(function populateCompletedTasks(response) {
				$('#entity-completed-tasks').html(response);
				$('.task-details').off().on('click', _openTaskDetailsFromEntitySection);
				$('.complete-task').off().on('click', _completeTaskFromEntitySection);
				$('.pin-task').off().on('click', _pinTaskFromEntitySection);

				TaskManager.sortTable($('#entity-completed-tasks .table-header-sort'), function callback(active_tab, page_num, order_by, sort_order)
				{
					_loadEntityTasks(active_tab, page_num, order_by, sort_order);
				});
			}
		);
	}

	function _loadTopMenuTabs()
	{
		// pinned tasks
		Adzuki.Ajax.get('/Tasks/pinnedTop')
			.then(function populatePinnedTasks(response) {
				$('#top-pinned').html(response);
				$('.tm-top.tab-content .task-details').off().on('click', _openTaskDetailsFromTopMenu);
				$('.tm-top.tab-content .complete-task').off().on('click', _completeTaskFromTopMenu);
				$('.tm-top.tab-content .pin-task').off().on('click', _pinTaskFromTopMenu);
			}
		);

		// past due tasks
		Adzuki.Ajax.get('/Tasks/pastDueTop')
			.then(function populatePastDueTasks(response) {
				$('#top-past_due').html(response);
				$('.tm-top.tab-content .task-details').off().on('click', _openTaskDetailsFromTopMenu);
				$('.tm-top.tab-content .complete-task').off().on('click', _completeTaskFromTopMenu);
				$('.tm-top.tab-content .pin-task').off().on('click', _pinTaskFromTopMenu);
			}
		);

		// due today tasks
		Adzuki.Ajax.get('/Tasks/dueTodayTop')
			.then(function populateDueTodayTasks(response) {
				$('#top-today').html(response);
				$('.tm-top.tab-content .task-details').off().on('click', _openTaskDetailsFromTopMenu);
				$('.tm-top.tab-content .complete-task').off().on('click', _completeTaskFromTopMenu);
				$('.tm-top.tab-content .pin-task').off().on('click', _pinTaskFromTopMenu);
			}
		);

		// due this week tasks
		Adzuki.Ajax.get('/Tasks/dueThisWeek')
			.then(function populateDueThisWeekTasks(response) {
				$('#top-this_week').html(response);
				$('.tm-top.tab-content .task-details').off().on('click', _openTaskDetailsFromTopMenu);
				$('.tm-top.tab-content .complete-task').off().on('click', _completeTaskFromTopMenu);
				$('.tm-top.tab-content .pin-task').off().on('click', _pinTaskFromTopMenu);
			}
		);

		// recently viewed tasks
		Adzuki.Ajax.get('/Tasks/recentlyViewed')
			.then(function populateRecentlyViewedTasks(response) {
				$('#top-recently_viewed').html(response);
				$('.tm-top.tab-content .task-details').off().on('click', _openTaskDetailsFromTopMenu);
				$('.tm-top.tab-content .complete-task').off().on('click', _completeTaskFromTopMenu);
				$('.tm-top.tab-content .pin-task').off().on('click', _pinTaskFromTopMenu);
			}
		);

		// create a quick task form
		Adzuki.Ajax.get('/Tasks/addQuick')
			.then(function addQuickTask(response) {
				$('#top-create_task').html(response);

				Adzuki.Form.initAjaxForm('TaskAddQuick');
			}
		);
	}

	function _openTaskDetailsFromEntitySection(e)
	{
		var $anchor_elem = $(this);

		e.preventDefault();

		TaskManager.openTaskDetails($anchor_elem);
	}

	function _openTaskDetailsFromTopMenu(e)
	{
		var $anchor_elem = $(this);

		e.preventDefault();

		TaskManager.openTaskDetails($anchor_elem);
	}

	function _openTaskManagerTopMenu(e)
	{
		// handle task manager icon click
		e.preventDefault();

		// AJAX requests for tabs contents
		_loadTopMenuTabs();
		_updateTopMenuTabNumbers();

		// if account messages are open, close it
		if ($('.account-messages-container').is(':visible')) {
			$('.account-messages-container').slideToggle('fast');
			$('.account-messages-link a').css('background-color', 'transparent');
		}

		// if quick actions is open, close it
		if ($('.quick-actions-container').is(':visible')) {
			$('.quick-actions-container').slideToggle('fast');
			$('.quick-actions-link a').css('background-color', 'transparent');
		}

		// if my shortcuts is open, close it
		if ($('.my-shortcuts-container').is(':visible')) {
			$('.my-shortcuts-container').slideToggle('fast');
			$('.my-shortcuts-link a').css('background-color', 'transparent');
		}

		// display task manager
		$('.task-manager-container').slideToggle('fast', function taskManagerSlideToggle() {
			if ($('.task-manager-container').is(':visible')) {
				$('.task-manager-link a').css('background-color', 'rgba(0,0,0,0.2)');
			} else {
				$('.task-manager-link a').css('background-color', 'transparent');
			}
		});
	}

	function _pinTaskFromEntitySection(e)
	{
		var $pin_elem = $(this);

		e.preventDefault();

		TaskManager.pinTask($pin_elem, function pinTaskCb(active_tab, page_num, order_by, sort_order) {
			_loadEntityTasks(active_tab, page_num, order_by, sort_order);
		});
	}

	function _pinTaskFromTopMenu(e)
	{
		var $pin_elem = $(this);

		e.preventDefault();

		TaskManager.pinTask($pin_elem, function pinTaskCb(active_tab, page_num) {
			_updateTopMenuTabNumbers();
			_loadTopMenuTabs();

			// flag that we made updates
			$('.tm-close').data('changed', 1);
		});
	}

	function _reloadPage()
	{
		var url        = Adzuki.erez_url + Adzuki.base_uri;
		var active_tab = 'pinned';

		// if we are on tasks main page, refresh the page
		// with the current tab still visible
		if ($('.tab-content.tasks-tabs').length > 0) {
			url += '/Tasks/index/tab:';

			if ($('#past-due-tasks-tab').hasClass('active')) {
				active_tab = 'past_due';
			} else if ($('#today-tasks-tab').hasClass('active')) {
				active_tab = 'today';
			} else if ($('#upcoming-tasks-tab').hasClass('active')) {
				active_tab = 'upcoming';
			} else if ($('#completed-tasks-tab').hasClass('active')) {
				active_tab = 'completed';
			}

			window.location.assign(url + active_tab);

			return;
		}

		window.location.reload();
	}

	function _removeTag(e)
	{
		var $remove_btn = $(this);
		var tag_id      = $remove_btn.data('tag-id');
		var form_id     = e.data.form_id;
		var tag_ids_str = $('#' + form_id + 'tag_ids').val();
		var tag_ids     = tag_ids_str.split(',');

		e.preventDefault();

		$.each(tag_ids, function onEachTagId(i, id) {
			if (tag_id === parseInt(id)) {
				tag_ids.splice(i, 1);
				return false; // break
			}
		});

		if (tag_ids.length > 0) {
			tag_ids_str = tag_ids.join(',');

			if (tag_ids.length < 2) {
				$('.' + form_id + 'match-tags').addClass('hidden');
			}
		} else {
			tag_ids_str = '';
			$('.' + form_id + 'match-tags').addClass('hidden');
		}

		// update ids in hidden field and remove tag from markup
		$('#' + form_id + 'tag_ids').val(tag_ids_str);
		$remove_btn.parent().remove();
	}

	function _removeTaskReference(e)
	{
		var $remove_btn  = $(this);
		var task_id      = $remove_btn.data('task-id');
		var task_list    = $remove_btn.data('task-list');
		var confirm_text = 'Are you sure you wish to remove the reference on this task?';
		var success_text = 'The reference has been removed from the task.';

		e.preventDefault();

		if (!task_id) {
			return;
		}

		// if we are removing a task from a task list, the wording is a bit different
		if (task_list) {
			confirm_text = 'Are you sure you wish to remove this task from the Task List?';
			success_text = 'The task has been removed from the Task List';
		}

		Adzuki.CustomConfirm({
			body   : confirm_text,
			confirm: function confirmRemoval() {
				var remove_url = '/Tasks/removeReference/' + task_id;

				Adzuki.Ajax.get(remove_url)
					.then(function taskReferenceRemoved(response) {
						if (response.status === 'success') {
							Adzuki.StatusMessage('success', success_text, 'Success');
							_renderTaskDetailsView(task_id);
							_renderTaskReferenceView(task_id);
							_renderTaskListView(task_id);
							_renderTaskHistoryView(task_id);
							$('#task-details-nav').data('changed', 1);
						} else {
							Adzuki.StatusMessage('error', response.error, 'Error!');
						}
					});
			},
		});
	}

	// display view with task attachments in modal
	function _renderTaskAttachmentsView(task_id)
	{
		Adzuki.Ajax.get('/Tasks/viewTaskAttachments/' + task_id)
			.then(function viewTaskAttachments(response) {
				$modal.find('#task-attachments').html(response);

				Adzuki.Form.initAjaxForm('TaskAttachmentAdd');
			});
	}

	// display view with task comments in modal
	function _renderTaskCommentsView(task_id)
	{
		Adzuki.Ajax.get('/Tasks/viewTaskComments/' + task_id)
			.then(function viewTaskComments(response) {
				$modal.find('#task-comments').html(response);

				Adzuki.Form.initAjaxForm('TaskCommentAddEdit');
			});
	}

	// display task details form in modal
	function _renderTaskDetailsView(task_id, read_only)
	{
		var url = '/Tasks/viewTaskDetails/' + task_id;

		if (read_only) {
			url += '/1';
		}

		Adzuki.Ajax.get(url)
			.then(function viewTaskDetails(response) {
				$modal.find('#task-details').html(response);

				Adzuki.Form.initAjaxForm('TaskAddEdit');
			});
	}

	// display task outcome form in a modal
	function _renderTaskOutcomeView(task_id)
	{
		Adzuki.Ajax.get('/Tasks/viewTaskOutcome/' + task_id)
			.then(function viewTaskOutcome(response) {
				$modal.find('#task-outcome').html(response);

				Adzuki.Form.initAjaxForm('TaskOutcome');
			});
	}

	// display the task list of a task in the modal
	function _renderTaskListView(task_id)
	{
		Adzuki.Ajax.get('/Tasks/viewTaskTaskList/' + task_id)
			.then(function viewTaskTaskList(response) {
				$modal.find('#task-task-list').html(response);

				if ($('#task-list-tasks').length > 0) {
					$('#task-list-tasks .complete-task').off().on('click', function completeTaskInModal(e)
					{
						var $check_elem = $(this);
						e.preventDefault();

						TaskManager.completeTask($check_elem, function completeTaskCb(active_tab, page_num) {
							_renderTaskListView(task_id);
						});
					});

					$('#task-list-tasks .view-task').off().on('click', function viewTaskInModal(e)
					{
						var $anchor_elem = $(this);
						e.preventDefault();

						if ($anchor_elem.hasClass('disabled')) {
							return;
						}

						TaskManager.openTaskDetails($anchor_elem);
					});
				}

				if ($('#task-task-list .remove-task-list-btn').length > 0) {
					$('#task-task-list .remove-task-list-btn').off().on('click', _removeTaskReference);
				}
			});
	}

	// display form to change the reference of a task in the modal
	function _renderTaskReferenceForm(e)
	{
		var $edit_btn = $(this);
		var task_id   = $edit_btn.data('task-id');

		e.preventDefault();

		if (!task_id) {
			return;
		}

		Adzuki.Ajax.get('/Tasks/viewTaskReferenceForm/' + task_id)
			.then(function viewTaskReferenceForm(response) {
				$modal.find('#task-reference').html(response);

				Adzuki.Form.initAjaxForm('TaskReferenceEdit');

				$('#task-reference .cancel-ref-update-btn').off().on('click', function onCancelBtnClick(e)
				{
					e.preventDefault();
					_renderTaskReferenceView(task_id);
				});
			});
	}

	// display view to show the reference of a task in the modal
	function _renderTaskReferenceView(task_id, read_only)
	{
		var url = '/Tasks/viewTaskReference/' + task_id;

		if (read_only) {
			url += '/1';
		}

		Adzuki.Ajax.get(url)
			.then(function viewTaskReference(response) {
				$modal.find('#task-reference').html(response);

				if ($('#task-reference .edit-task-ref-btn').length > 0) {
					$('#task-reference .edit-task-ref-btn').off().on('click', _renderTaskReferenceForm);
				}

				if ($('#task-reference .remove-task-ref-btn').length > 0) {
					$('#task-reference .remove-task-ref-btn').off().on('click', _removeTaskReference);
				}
			});
	}

	// display task history in modal
	function _renderTaskHistoryView(task_id)
	{
		Adzuki.Ajax.get('/Tasks/viewTaskHistory/' + task_id)
			.then(function viewTaskHistory(response) {
				$modal.find('#task-history').html(response);
			});
	}

	function _resetAndHideTaskListTypeaheads()
	{
		$.each(TaskManager.entities, function onEachEntity(i, entity) {
			$('.reset-' + entity + '-typeahead').trigger('click');
			$('.' + entity + '-typeahead').addClass('hidden');
		});
	}

	function _showBasedOnFields()
	{
		$('.due-based-on-field').removeClass('hidden');
		$('.default-due-date').addClass('hidden');
	}

	function _showNoDefaultDueDateWarning(form_id)
	{
		var entity_type  = $('#' + form_id + 'classification').val();
		var due_based_on = $('#' + form_id + 'due_based_on').val();
		var $due_warning = $('.no-default-due-date-warning');
		var entity_label = null;

		if ($due_warning.length === 0) {
			return;
		}

		$due_warning.addClass('hidden');

		if (due_based_on !== 'no_due_date') {
			return;
		}

		if (entity_type) {
			entity_label = Adzuki.String.capitalize(entity_type);
		}

		Adzuki.Ajax.get('/Tasks/getClassificationLabel/' + entity_type)
		.then(function getClassificationLabel(response)
		{
			entity_label = response.label;

			$due_warning.html('This task will not be applied to a <strong>' + entity_label + '</strong> if the template is set to "auto apply". When manually applying this template to a <strong>' + entity_label + '</strong>, you will have to set the due date for this task.');

			$due_warning.removeClass('hidden');
		});
	}

	function _showOrHideTasksButtons()
	{
		var $incomplete_tasks_elem = $('#entity-incomplete-tasks .tasks-table-container ul.table');

		if ($incomplete_tasks_elem.length > 0) {
			$('.complete-entity-tasks-btn').removeClass('hidden');
			$('.delete-entity-tasks-btn').removeClass('hidden');
			return;
		}

		$('.complete-entity-tasks-btn').addClass('hidden');
		$('.delete-entity-tasks-btn').addClass('hidden');
	}

	function _tabMustFadeout(no_fadeout_tabs, tab_name)
	{
		var must_fadeout = true;

		$.each(no_fadeout_tabs, function onEachTabName(i, val) {
			if (tab_name.indexOf(val) !== -1) {
				must_fadeout = false;
				return false; // break out of the loop
			}
		});

		return must_fadeout;
	}

	function _updateTopMenuTabNumbers()
	{
		Adzuki.Ajax.get('/Tasks/getTasksCounts')
			.then(function getTasksCounts(response) {
				var pinned_count    = parseInt(response.pinned_count);
				var past_due_count  = parseInt(response.due_count);
				var today_count     = parseInt(response.today_count);
				var this_week_count = parseInt(response.due_this_week_count);
				var total_count     = 0;

				total_count = pinned_count + past_due_count + today_count + this_week_count;

				// update badge numbers
				if ($('#top-pinned-tab').length > 0) {
					$('#top-pinned-tab .badge').text(pinned_count);
				}

				if ($('#top-past_due-tab').length > 0) {
					$('#top-past_due-tab .badge').text(past_due_count);
				}

				$('#top-today-tab .badge').text(response.today_count);
				$('#top-this_week-tab .badge').text(response.this_week_count);
				$('.task-manager-link a').attr('data-amount', total_count);
			}
		);
	}

	Adzuki.TaskManager = TaskManager;
}(jQuery, window.Adzuki || {}));
